import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import TopBar from '../components/TopBar';
import Api from '../utils/Api';

import "../style/Profile.css";

// Profile Component
class Profile extends Component {
    constructor() {
        super();
        this.state = {
            user: null,
            oldPassword: '',
            password: '',
            passwordConfirmation: '',
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.submitPassword = this.submitPassword.bind(this);
        this.handlePasswordError = this.handlePasswordError.bind(this);
        this.handlePasswordSuccess = this.handlePasswordSuccess.bind(this);
    }

    componentDidMount() {
        Api.getUserInfo()
        .then((res) => {
            this.setState({ user : res });
        }).catch(err => {
            if (err.status === 403 || err.status === 401) {
                this.setState({ logout: true });
            }
        });
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        this.setState({
          [name]: value
        });
    }

    handlePasswordSuccess() {
        const successAlert = (<div className="alert alert-success">
            Votre mot de passe a été modifié
        </div>);
        this.setState({ successAlert, errorAlert: null, oldPassword: '', password : '', passwordConfirmation: '' });
    }

    handlePasswordError(err) {
        let text = '';
        if (err.code === "NotAuthorizedException")
            text = 'Votre ancien mot de passe n\'est pas valide';
        else if (err.code === "LimitExceededException")
            text = 'Trop de tentatives échouées. Merci de réessayer plus tard';
        else if (err.code === "InvalidPasswordException" || err.code === "InvalidParameterException")
            text = 'Votre nouveau mot de passe n\'est pas conforme, il doit faire au moins 8 caractères et comporter au moins un chiffre, une lettre minuscule et une lettre majuscule.';
        else
            text = 'Une erreur s\'est produite merci de nous contacter';
        
        const errorAlert = (<div className="alert alert-warning">
            {text}
        </div>);
        this.setState({ errorAlert, oldPassword: '', password : '', passwordConfirmation: '' });
    }

    submitPassword(e) {
        e.preventDefault();
        Api.updatePassword(this.state.oldPassword, this.state.password)
        .then(res => {
            this.handlePasswordSuccess();
        }).catch((err) => {
            this.handlePasswordError(err.response.body);
        })
    }
    

    render() {
        if (this.state.logout)
            return <Redirect to="/login" />

        const userBlock = this.state.user ? (
            <div>
                <div className="profile-row">
                    <span className="label">
                        <i className="gradient-icon-blue pe-7s-ticket"></i>
                        Entreprise :
                    </span>
                    <span className="value">
                        {this.state.user.brandname}
                    </span>
                </div>
                <div className="profile-row">
                    <span className="label">
                        <i className="gradient-icon-blue pe-7s-map-marker"></i>
                        Adresse :
                    </span>
                    <span className="value">
                        {`${this.state.user.address}, ${this.state.user.postalcode} ${this.state.user.city} ${this.state.user.country}`}
                    </span>
                </div>
                <div className="profile-row">
                    <span className="label">
                        <i className="gradient-icon-blue pe-7s-mail"></i>
                        E-mail :
                    </span>
                    <span className="value">
                        {this.state.user.email}
                    </span>
                </div>
                <div className="profile-row">
                    <span className="label">
                        <i className="gradient-icon-blue pe-7s-phone"></i>
                        Telephone :
                    </span>
                    <span className="value">
                        {this.state.user.phone}
                    </span>
                </div>

            </div>
        ) : null;

        return(
            <div className="route-wrapper">
                <TopBar
                    title="Mon profil"
                    subheading="Vos informations."
                    icon="pe-7s-user"
                />
                <div className="app-inner-layout">
                    <div className="app-inner-layout-content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="card">
                                        <div className="card-header">
                                            <i className="pe-7s-info header-icon gradient-icon-blue"></i>
                                            Mes informations
                                        </div>
                                        <div className="card-body">
                                            {this.state.user && userBlock}
                                            <hr/>
                                            <div className="alert alert-info">
                                                Pour toute question concernant votre compte n'hésitez pas à nous contacter via notre site ou au 
                                                <br />
                                                <a href="tel:+33766287069 ">07 66 28 70 69 </a>.
                                                <br/>
                                                <br/>
                                                <a href="https://ranky.io" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline"}}>Ouvrir le site</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="card">
                                        <div className="card-header">
                                            <i className="pe-7s-key header-icon gradient-icon-blue"></i>
                                            Changer mon mot de passe
                                        </div>
                                        <div className="card-body">
                                        <form>
                                            <div className="form-group">
                                                <label htmlFor="password">Votre ancien mot de passe :</label>
                                                <input value={this.state.oldPassword} type="password" onChange={this.handleInputChange} className="form-control" id="oldPassword" name="oldPassword"/>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="password">Votre nouveau mot de passe :</label>
                                                <input value={this.state.password} type="password" onChange={this.handleInputChange} className="form-control" id="password" name="password"/>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="passwordConfirmation">Confirmation :</label>
                                                <input value={this.state.passwordConfirmation} type="password" onChange={this.handleInputChange} className="form-control" id="passwordConfirmation" name="passwordConfirmation"/>
                                            </div>
                                            {this.state.errorAlert || this.state.successAlert || null}
                                            <button
                                                type="submit"
                                                className="btn btn-primary btn-sm"
                                                onClick={this.submitPassword}
                                                disabled={!(this.state.password.length && this.state.oldPassword.length &&  this.state.password === this.state.passwordConfirmation)}
                                            >
                                                    <i className="pe-7s-check"></i>
                                                    Valider
                                            </button>
                                        </form>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}
export default Profile;



// WEBPACK FOOTER //
// ./src/containers/Profile.js